import queryString from 'query-string';
import { apiFetch } from './utils';

export const portfolioCashflow = {
  get: async (args) => {
    const options = {
      method: 'GET',
    };

    const query = queryString.stringify(args, { arrayFormat: 'comma' });

    const url = `/v3/portfolio-cash-flows?${query}`;

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
